module.exports = __webpack_public_path__ + "static/media/indigo-logo.ab7f906b.png";